import React from "react";
import { BsArrowLeftRight } from "react-icons/bs";
import EAIconButton from "../../../app/components/shared/Buttons/EAIconButton";

interface IProps {
  facilityIds: string;
}

const KrakowShopChanger: React.FC<IProps> = ({ facilityIds }) => {
  const onChangeKrakowShop = () => {
    if (facilityIds === "1243") {
      window.location.href = "https://panel.eaktywni.pl/eAktywniReactApp/customOffer?offerId=sklep?id=1241";
    } else if (facilityIds === "1241") {
      window.location.href = "https://panel.eaktywni.pl/eAktywniReactApp/customOffer?offerId=sklep?id=1243";
    }
  };

  const getImageUrl = () => {
    if (facilityIds === "1243") {
      return "https://panel.eaktywni.pl/img/1241/pk_krakow.png";
    } else if (facilityIds === "1241") {
      return "https://panel.eaktywni.pl/img/1243/fitpark.png";
    }
    return "";
  };

  return (
    <div className="krakow-switch">
      <EAIconButton icon={<BsArrowLeftRight />} title="Przełącz sklep" variant="icon" onClick={onChangeKrakowShop} />
      <img src={getImageUrl()} alt="Logo sklepu" />
    </div>
  );
};

export default KrakowShopChanger;
